import { useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import { mensajeError } from './acceso';

export function Entrar({ sb, onListo }: { sb: SupabaseClient; onListo: () => void }) {
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const entrar = async (e: Event) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !clave) { setError('Escribe tu correo y tu contraseña.'); return; }
    setEnviando(true);
    const { error } = await sb.auth.signInWithPassword({ email: email.trim().toLowerCase(), password: clave });
    setEnviando(false);
    if (error) { setError(mensajeError(error)); return; }
    onListo();
  };
  return (
    <form class="panel form" onSubmit={entrar} aria-label="Entrar al sistema">
      <h2>Entrar</h2>
      <label for="correo">Correo</label>
      <input id="correo" class="in" type="email" autocomplete="username" value={email} onInput={e => setEmail(e.currentTarget.value)} />
      <label for="clave">Contraseña</label>
      <input id="clave" class="in" type="password" autocomplete="current-password" value={clave} onInput={e => setClave(e.currentTarget.value)} />
      {error && <p class="error" role="alert">{error}</p>}
      <button class="btn primary" type="submit" disabled={enviando}>{enviando ? 'Entrando…' : 'Entrar'}</button>
      <p class="hint">¿Olvidaste la contraseña? Por ahora, Felipe la cambia desde Supabase.</p>
    </form>
  );
}
